import {MVEditor} from './_multi-value-editor';
import {ConnectionEditor} from "./_connection-editor";
import {ListMultiSelectEditor} from "./_list-multiselect-editor";

const ContactModal = {};

(function () {

    $(window).on('afterContactModalModeToggleEdit onRenderModalMergeComplete', function (e) {
        if(typeof(tableManager) !== 'undefined'){
            tableManager.setState('card-edit')
        }


        $('.full-editor-multi').each((index, formEditorEl) => {
            MVEditor.initPhoneTypeSelectrs($(formEditorEl));
            MVEditor.initBtns($(formEditorEl));
        });

        initConnectionEditFormField()
        initSelectMultiEditFormFields()

        if(e.type === 'afterContactModalModeToggleEdit'){
            initEditForm();
        }

        if(e.type === 'onRenderModalMergeComplete'){
            initMergeForm();

            initConnectionEditFormField();
            initSelectMultiEditFormFields();
        }

    })

    $(window).on('pageLoadContactCreateForm', function () {
        initConnectionEditFormField();
        initSelectMultiEditFormFields();
    });

    /**
     * More convenient to use initSelectMultiEditFormFields instead
     * @deprecated
     */
    function initConnectionEditFormField() {
        const $connectionField = $(".editable-field-connection-wrapper [data-connection='init']");
        if($connectionField.length === 0) {
            return;
        }
        ConnectionEditor.renderForTag($connectionField[0], {
            dropdownParent: null,
            onChange(value){

            }
        });
    }

    function initSelectMultiEditFormFields() {
        $(".editable-field-select-multi-wrapper").each((index, htmlElement) => {

            let field = $(htmlElement).data('field');

            ListMultiSelectEditor.renderForTag($(htmlElement).find(`[data-${field}='init']`)[0], {
                dropdownParent: null,
                onChange(value){

                }
            });
        })

    }


    function initMergeForm() {
        $('._contact-merge-form').on('submit', function (e) {
            e.preventDefault();

            let formElement = this;
            let $form = $(formElement);

            $(formElement).find('[data-attach-loading]').addClass('oc-loading').prop('disabled', true);

            $(formElement).request('onBulkAction', {
                flash: true,
                data: {
                    contact: {
                        phones: MVEditor.collectPhones($('input[name="selected_keys[phones]"]:checked').closest('._valuesGroup').find('.full-editor-multi._phones'))
                    }
                },
                complete: function (resp,state) {
                    if(typeof(tableManager) !== 'undefined'){
                        tableManager.setState('card-view');
                    }
                    myCustomEventDispatch("afterContactsMerge", resp.responseJSON )
                    this.complete();

                }
            });
        });
    }

    function initEditForm() {
        $('._contact-edit-form').on('submit', function (e) {
            e.preventDefault();

            let formElement = this;
            let $form = $(formElement);

            let connectionsValue = [];
            if($form.find('.connection-select').length > 0){
                let foundSelect = $form.find('.connection-select')[0]
                if(foundSelect.selectize){
                    connectionsValue = foundSelect.selectize.getValue();
                }
            }

            let myDataAddon = {
                connections: connectionsValue,
                phones: MVEditor.collectPhones($form.find('.full-editor-multi._phones')),
                pseudonyms: {
                    first_name: MVEditor.collectValues($form.find('.full-editor-multi._pseudonyms_fname')),
                    last_name: MVEditor.collectValues($form.find('.full-editor-multi._pseudonyms_lname')),
                },
            };

            const $multiSelects = $form.find('.editable-field-select-multi-wrapper');
            if($multiSelects.length > 0){
                $multiSelects.each((index, htmlElement) => {
                    myDataAddon[htmlElement.dataset.field] =
                        $(htmlElement).find(`select[data-${htmlElement.dataset.field}]`)[0].selectize.getValue();
                })
            }

            $(formElement).request('onSaveContact', {
                data: myDataAddon,
                success: function (data, textStatus, jqXHR) {
                    if($form.find('.connection-select').length > 0){
                        let foundSelect = $form.find('.connection-select')[0]
                        if(foundSelect.selectize){
                            connectionsValue = foundSelect.selectize.destroy();
                        }
                    }

                    if($multiSelects.length > 0){
                        $multiSelects.each((index, htmlElement) => {
                            $(htmlElement).find(`select[data-${htmlElement.dataset.field}]`)[0].selectize.destroy();
                        })
                    }

                    if(typeof(tableManager) !== 'undefined'){
                        tableManager.setState('card-view');
                    }
                    this.success(data, textStatus, jqXHR);
                },
                complete: function () {

                    this.complete();
                }
            });
        });

        myCustomEventDispatch('entryModalFormModeToggleEdit');
    }

    if($('._contact-edit-form').length > 0){
        let $formEditorEl = $('.full-editor-multi');


        MVEditor.initPhoneTypeSelectrs($formEditorEl);
        MVEditor.initBtns($formEditorEl);

        initEditForm();
    }

})();

export { ContactModal };
